module.exports = __webpack_public_path__ + "img/AdvancedResults.053d5805.png";